/* ==========================================================================
  main.js
========================================================================== */

/**
 * Detect old IE
 */
(function cor_detect_ie() {

    var ua = window.navigator.userAgent;

    // IE 10 or older
    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        document.querySelector('body').className += ' browser-ie';
    }

    // IE 11
    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
      document.querySelector('body').className += ' browser-ie';
    }

    // edge
    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
      document.querySelector('body').className += ' browser-edge';
    }

    // other browser
    return false;

})();

/**
 * Navigation
 *
 * Apply only to first nav (duplicated for other uses)
 */
var active_network_ancestors = document.querySelectorAll('.js-network-navigation .current-menu-ancestor');
for (var i = 0; i < active_network_ancestors.length; i++) {
  active_network_ancestors[i].classList.add('active');
  var network_submenu = active_network_ancestors[i].querySelector('.sub-menu');
  if (network_submenu) {
    network_submenu.classList.add('open');
  }
  var network_button = active_network_ancestors[i].querySelector('button');
  if (network_button) {
    network_button.setAttribute('aria-expanded', 'true');
  }
}

aucor_navigation(document.querySelector('.js-network-navigation'), {
  menu_toggle: '#network-menu-toggle', // selector for toggle
  active_class: 'network-menu-active',
  html_active_class: 'document-network-menu-active',
  sub_menu_hover: false
});

if (document.querySelector('#site-menu-toggle')) {

  // wrap megemenu => ul.sub-menu > li => div.sub-menu > ul.mega-menu > li
  var megamenu_containers = document.querySelectorAll('#site-navigation .menu-item--has-megamenu > .sub-menu');
  for (var i = 0; i < megamenu_containers.length; i++) {
    megamenu_containers[i].classList.add('mega-menu');
    megamenu_containers[i].classList.remove('sub-menu');
    megamenu_containers[i].outerHTML = "<div class='sub-menu'>" + megamenu_containers[i].outerHTML + "</div>";
  }
  // listen hover for site-header
  var site_header = document.querySelector('.js-site-header .site-navigation');
  if (site_header) {
    site_header.addEventListener('mouseenter', function(e) {
      e.currentTarget.classList.add('site-header--hover');
      if (document.querySelector('#page')) {
        document.querySelector('#page').classList.add('site-menu-hover');
      }
    });
    site_header.addEventListener('mouseleave', function(e) {
      e.currentTarget.classList.remove('site-header--hover');
      if (document.querySelector('#page')) {
        document.querySelector('#page').classList.remove('site-menu-hover');
      }
    });
    var site_header_links = site_header.querySelectorAll('a, button');
    for (var i = 0; i < site_header_links.length; i++) {
      site_header_links[i].addEventListener('focus', function(e) {
        var parentNode = e.target.parentNode;
        while (parentNode && parentNode.nodeName && parentNode.parentNode) {
          if (parentNode.classList && parentNode.classList.contains('js-site-header')) {
            parentNode.classList.add('site-header--focus');
          }
          parentNode = parentNode.parentNode;
        }
      });
      site_header_links[i].addEventListener('blur', function(e) {
        var parentNode = e.target.parentNode;
        while (parentNode && parentNode.nodeName && parentNode.parentNode) {
          if (parentNode.classList && parentNode.classList.contains('js-site-header')) {
            parentNode.classList.remove('site-header--focus');
          }
          parentNode = parentNode.parentNode;
        }
      });
    }
    // modify menu item "title" items
    var site_header_menu_items = site_header.querySelectorAll('.js-menu-item-title');
    for (var i = 0; i < site_header_menu_items.length; i++) {
      var link = site_header_menu_items[i].querySelector(':scope > a, :scope > .menu-item-label');
      if (link) {
        if (link.tagName === 'SPAN') {
          link.classList.remove('menu-item-label');
          link.classList.add('menu-item-title-label');
        } else {
          link.outerHTML = "<span class='menu-item-title-label'>" + link.innerHTML + "</span>";
        }
      }
      var icon = site_header_menu_items[i].querySelector('.list-icon');
      if (icon) {
        icon.remove();
      }
    }
    // add counts of .js-menu-item-title of each .megamenu
    var megamenus = site_header.querySelectorAll('.mega-menu');
    for (var i = 0; i < megamenus.length; i++) {
      var menu_items = megamenus[i].querySelectorAll('.js-menu-item-title');
      if (menu_items.length > 0) {
        megamenus[i].classList.add('mega-menu--has-titles-' + menu_items.length);
      }
    }
  }
  aucor_navigation(document.getElementById('site-navigation'), {
    desktop_min_width: 1024, // min width in pixels
    menu_toggle: '#site-menu-toggle', // selector for toggle,
    active_class: 'site-menu-active',
    html_active_class: 'document-site-menu-active',
    sub_menu_hover: false
  });
  var active_ancestors = document.querySelectorAll('#site-navigation .current-menu-ancestor, #site-navigation .current-menu-item');
  // if screen width is less thand 1024 px
  if (window.innerWidth < 1024) {
    for (var i = 0; i < active_ancestors.length; i++) {
      active_ancestors[i].classList.add('active');
      var submenu = active_ancestors[i].querySelector('.sub-menu');
      if (submenu) {
        submenu.classList.add('open');
      }
      var button = active_ancestors[i].querySelector('button');
      if (button) {
        button.setAttribute('aria-expanded', 'true');
      }
    }
  }


}

/**
 * Language menu
 */
var cor_language_menu = function() {
  var page = document.getElementById('page');
  var lang_menu = document.getElementById('lang-menu');

  if (lang_menu) {
    lang_menu.querySelector('.lang-menu__button').addEventListener('click', function(){
      if (page.classList.contains('lang-menu-active')) {
        page.classList.remove('lang-menu-active');
      } else {
        page.classList.add('lang-menu-active');

        // also close serch
        var search_close = document.getElementById('header-search-close');
        if (search_close) {
          search_close.click();
        }
      }
    });
  }
};

cor_language_menu();

/**
 * Accordion
 */

// dom ready

const initAccordions = () => {
  var accordion = document.querySelectorAll('.js-accordion-header');

  var accordion_init = function(accordion, i) {
    var tab = accordion;
    var panel = accordion.parentNode.querySelector('.js-accordion-panel');

    if (tab.getAttribute('aria-expanded') !== 'true') {
      tab.setAttribute('aria-expanded', 'false');
    }
    tab.setAttribute('type', 'button');
    tab.setAttribute('aria-controls', 'accordion-' + i);

    panel.setAttribute('id', 'accordion-' + i);
    if (panel.getAttribute('aria-hidden') !== 'false') {
      panel.setAttribute('aria-hidden', 'true');
    }
    panel.setAttribute('aria-labelledby', 'accordion-' + i);
  };

  var accordion_focus = function(e) {
    var tab = e.target;

  };

  var accordion_toggle = function(e) {
    var tab = e.target;
    var panel = e.target.parentNode.querySelector('.js-accordion-panel');

    if (tab.getAttribute('aria-expanded') === 'true') {
      tab.setAttribute('aria-expanded', 'false');
      panel.setAttribute('aria-hidden', 'true');
    } else {
      tab.setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-hidden', 'false');
    }
  };

  for (var i = 0; i < accordion.length; i++) {

    if (accordion[i].getAttribute('data-init') !== null) {
      continue;
    }

    accordion[i].setAttribute('data-init', 'true');

    accordion_init(accordion[i], i);

    accordion[i].addEventListener('click', function(e) {
      e.stopPropagation();

      accordion_toggle(e);
    });

    accordion[i].addEventListener('focus', accordion_focus, false);
    accordion[i].addEventListener('blur', accordion_focus, false);
  }
};

document.addEventListener('DOMContentLoaded', initAccordions);
document.addEventListener('GrowthstackABTestReplacementAfter', initAccordions);
document.addEventListener('CoronariaOfficesNearbyDone', initAccordions);


/**
 * Sticky header
 */
var header = document.getElementById('masthead');

var headroom  = new Headroom(header, {
  offset: 64,
  tolerance: {
    up: 24,
    down: 0
  }
});

headroom.init();

/**
 * Filter for company list
 */
function companyFilter() {
  var input, filter, cards, cardContainer, h2, title, i;
  input = document.getElementById("company-search-input");
  filter = input.value.toUpperCase();
  cardContainer = document.getElementById("companies__block");
  cards = cardContainer.getElementsByClassName("card");
  for (i = 0; i < cards.length; i++) {
      title = cards[i].querySelector(".card__header h2.card__title");
      if (title.innerText.toUpperCase().indexOf(filter) > -1) {
          cards[i].style.display = "";
      } else {
          cards[i].style.display = "none";
      }
  }
}

/**
 * Slideshows
 */

var slideshow_init = function(slideshow) {
  var selector = slideshow.querySelector('.js-slideshow-slides');
  var slides = slideshow.querySelectorAll('.js-slideshow-slide');
  var pagination = slideshow.querySelectorAll('.js-slideshow-page');

  // get num of slides and bail if only one exists
  if (slides.length <= 1) {
    return;
  }

  // toggle active pagination item class
  var active_page = function(pagination, current) {
    for (var i = 0; i < pagination.length; i++) {
      var page = pagination[i].value;

      if (parseInt(page) === parseInt(current)) {
        pagination[i].classList.add('slideshow__page--current');
      } else {
        pagination[i].classList.remove('slideshow__page--current');
      }
    }
  };

  // set height based on current slide on init and change
  var set_height = function(slider) {
    var el = slider.innerElements[slider.currentSlide];
    slider.selector.style.height = el.offsetHeight + 'px';
  };

  // init slideshow
  var siema = new Siema({
    selector: selector,
    loop: true,
    onInit: function() {
      active_page(pagination, this.currentSlide);
      set_height(this);
    },
    onChange: function() {
      active_page(pagination, this.currentSlide);
      set_height(this);
    },
  });

  window.addEventListener('resize', function() {
    set_height(siema);
  });

  window.addEventListener('load', function() {
    set_height(siema);
  });

  // prev and next buttons
  slideshow.querySelector('.js-slideshow-prev').addEventListener('click', function(e) {
    siema.prev();
  });

  slideshow.querySelector('.js-slideshow-next').addEventListener('click', function(e) {
    siema.next();
  });

  //pagination
  for (var i = 0; i < pagination.length; i++) {
    pagination[i].addEventListener('click', function(e) {
      siema.goTo(parseInt(e.currentTarget.value));
    });
  }
};

// loop through slideshows
var slideshows = document.querySelectorAll('.js-slideshow');

for (var i = 0; i < slideshows.length; i++) {
  slideshow_init(slideshows[i]);
}

/**
 * Front hero accordions
 */
function cor_scroll_to_front_hero_section(el) {

  window.scroll(0, el.offsetTop);

}
function cor_front_hero_sections_click(e) {

  var section = e.currentTarget.parentNode;
  var window_width = window.innerWidth || document.documentElement.clientWidth ||
  document.body.clientWidth;
  var is_desktop = (window_width >= 715);
  var sections = document.querySelectorAll('.js-hero-appointments__section');

  if (is_desktop) {
    if (section.classList.contains('hero-appointments__section--disable-desktop')) {
      // is disabled
      return;
    } else if (section.classList.contains('hero-appointments__section--open-desktop')) {
      // is open
      section.classList.add('hero-appointments__section--closed-desktop');
      section.classList.remove('hero-appointments__section--open-desktop');
    } else {
      // is closed
      // close others
      for (var i = 0; i < sections.length; i++) {
        sections[i].classList.add('hero-appointments__section--closed-desktop');
        sections[i].classList.remove('hero-appointments__section--open-desktop');
      }
      section.classList.remove('hero-appointments__section--closed-desktop');
      section.classList.add('hero-appointments__section--open-desktop');
      cor_scroll_to_front_hero_section(section);
    }
    // is closed
  } else {
    if (section.classList.contains('hero-appointments__section--disable-mobile')) {
      // is disabled
      return;
    } else if (section.classList.contains('hero-appointments__section--open-mobile')) {
      // is open
      section.classList.add('hero-appointments__section--closed-mobile');
      section.classList.remove('hero-appointments__section--open-mobile');
    } else {
      // is closed
      // close others
      for (var i = 0; i < sections.length; i++) {
        sections[i].classList.add('hero-appointments__section--closed-mobile');
        sections[i].classList.remove('hero-appointments__section--open-mobile');
      }
      section.classList.remove('hero-appointments__section--closed-mobile');
      section.classList.add('hero-appointments__section--open-mobile');
      cor_scroll_to_front_hero_section(section);
    }
  }

}
var front_hero_sections = document.querySelectorAll('.js-hero-appointments__heading');
for (var i = 0; i < front_hero_sections.length; i++) {
  front_hero_sections[i].addEventListener('click', cor_front_hero_sections_click);
}

/**
 * Add identifiers for first and last block
 */
var tagFirstAndLastBlock = function () {

  var blocks = document.querySelector('.wysiwyg');
  if (blocks) {
    for (var i = 0; i < blocks.childNodes.length; i++) {
      if (blocks.childNodes[i].nodeType !== 3 && typeof blocks.childNodes[i].classList !== "undefined") {
        blocks.childNodes[i].classList.add('is-first-block');
        break;
      }
    }
    for (var i = (blocks.childNodes.length - 1); i >= 0; i--) {
      if (blocks.childNodes[i].nodeType !== 3 && typeof blocks.childNodes[i].classList !== "undefined") {
        blocks.childNodes[i].classList.add('is-last-block');
        break;
      }
    }
    var innerBlocks = blocks.querySelectorAll('.coronaria-section__content-wrapper');

    for (var j = 0; j < innerBlocks.length; j++) {
      var innerBlockSection = innerBlocks[j];
      for (var i = 0; i < innerBlockSection.childNodes.length; i++) {
        if (innerBlockSection.childNodes[i].nodeType !== 3 && typeof innerBlockSection.childNodes[i].classList !== "undefined") {
          innerBlockSection.childNodes[i].classList.add('is-first-inner-block');
          break;
        }
      }
      for (var i = (innerBlockSection.childNodes.length - 1); i >= 0; i--) {
        if (innerBlockSection.childNodes[i].nodeType !== 3 && typeof innerBlockSection.childNodes[i].classList !== "undefined") {
          innerBlockSection.childNodes[i].classList.add('is-last-inner-block');
          break;
        }
      }
    }

  }


};
tagFirstAndLastBlock();

/**
 * Add column type
 */
var addColumnTypeClasses = function() {

  var columnBlocks = document.querySelectorAll('.wp-block-column');
  if (columnBlocks.length) {
    for (var i = 0; i < columnBlocks.length; i++) {
      var columnBlock = columnBlocks[i];
      var children = columnBlock.querySelectorAll(':scope > *');
      var listBlock = columnBlock.querySelector('.wp-block-list');
      var imageBlock = columnBlock.querySelector('.wp-block-image');
      var buttonBlock = columnBlock.querySelector('.wp-block-buttons, .wp-block-button');
      var backgroundBlock = columnBlock.querySelector('.wp-block-background');
      if (imageBlock && children.length == 1) {
        columnBlock.classList.add('is-image-column');
      } else if (backgroundBlock && children.length == 1) {
        columnBlock.classList.add('is-background-column');
      } else if (listBlock && children.length == 1) {
        columnBlock.classList.add('is-list-column');
      } else if (buttonBlock && children.length == 1) {
        columnBlock.classList.add('is-button-column');
      } else {
        columnBlock.classList.add('is-content-column');
        // if last child is .wp-block-buttons
        if (children.length > 0 && (children[children.length - 1].classList.contains('wp-block-buttons') || children[children.length - 1].classList.contains('wp-block-button'))) {
          columnBlock.classList.add('is-buttoned-column');
        }
      }
    }
  }

};
document.addEventListener('DOMContentLoaded', addColumnTypeClasses);
document.addEventListener('GrowthstackABTestReplacementAfter', addColumnTypeClasses);

/**
 * Real arrows to buttons
 */
var addRealArrowsToButtons = function() {

    var buttons = document.querySelectorAll('.wp-block-button__link, .button');
    if (buttons.length) {
      for (var i = 0; i < buttons.length; i++) {
        var button = buttons[i];
        if (button.innerHTML.indexOf('&gt;') > -1) {

          // clean up markup
          button.innerHTML = button.innerHTML.replace('&gt;&gt;', '&gt;');
          button.innerHTML = button.innerHTML.replace(' &gt;', '&gt;');
          button.innerHTML = button.innerHTML.replace(' &gt;', '&gt;');

          button.classList.add('is-arrow-button');
          button.innerHTML = button.innerHTML.replace('&gt;', '&nbsp;<svg class="dynamic-button-arrow" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><polygon points="9 6 7.59 7.41 12.17 12 7.59 16.59 9 18 15 12"/></svg>');
        }
      }
    }

}
addRealArrowsToButtons();
document.addEventListener("DOMContentLoaded", addRealArrowsToButtons);
document.addEventListener("GrowthstackABTestReplacementAfter", addRealArrowsToButtons);


/**
 * Remove obsolete dividers
 */
var removeObsoleteDividers = function() {

    var dividers = document.querySelectorAll('.wp-block-separator');
    if (dividers.length) {
      for (var i = 0; i < dividers.length; i++) {
        var divider = dividers[i];

        var blocksWithBackground = [
          'related-block',
          'wp-block-coronaria-section'
        ];

        var ignoreClass = 'has-white-background-color';

        // if next sibling has background
        if (divider.nextElementSibling && divider.nextElementSibling.classList) {
          for (var j = 0; j < blocksWithBackground.length; j++) {
            if (divider.nextElementSibling.classList.contains(blocksWithBackground[j]) && !divider.nextElementSibling.classList.contains(ignoreClass)) {
              divider.remove();
              break;
            }
          }
        }
        // if previous sibling has background
        if (divider.previousElementSibling && divider.previousElementSibling.classList) {
          for (var j = 0; j < blocksWithBackground.length; j++) {
            if (divider.previousElementSibling.classList.contains(blocksWithBackground[j]) && !divider.previousElementSibling.classList.contains(ignoreClass)) {
              divider.remove();
              break;
            }
          }
        }
      }
    }

  }
removeObsoleteDividers();

/**
 * Init Leadoo bots
 */
const initLeadooBots = () => {
  const leadoos = document.querySelectorAll('.js-leadoo-bot');
  if (leadoos.length) {
    for (let i = 0; i < leadoos.length; i++) {
      if (leadoos[i].getAttribute('data-init') !== null) {
        continue;
      }
      leadoos[i].setAttribute('data-init', 'true');
      const leadoo = leadoos[i].dataset.leadoo;
      const hasEmbedAlready = leadoos[i].querySelector('script, iframe');
      const isInpageEmbed = leadoo && leadoo.includes('/bot/inpage.html');
      if (leadoo && !hasEmbedAlready) {
        if (isInpageEmbed) {
          const iframe = document.createElement('iframe');
          iframe.src = leadoo;
          iframe.setAttribute('data-ld-type', 'inpage');
          iframe.setAttribute('title', 'Leadoo');
          iframe.setAttribute('loading', 'lazy');
          iframe.setAttribute('frameborder', '0');
          iframe.setAttribute('scrolling', 'no');
          iframe.style.width = '100%';
          iframe.style.border = '0';
          iframe.style.minHeight = '700px';
          leadoos[i].appendChild(iframe);
          continue;
        }

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = leadoo;
        script.setAttribute('data-cookieconsent', 'ignore');
        leadoos[i].appendChild(script);
      }
    }
  }
};
document.addEventListener('DOMContentLoaded', initLeadooBots);
document.addEventListener('GrowthstackABTestReplacementAfter', initLeadooBots);

/**
 * A/B test: add class to body
 */
var addABTestClassToBody = function() {
  document.body.classList.add('is-ab-test');
}

window.addEventListener( 'CorABTestActive', addABTestClassToBody );

// trigger CorABTestActive
// var abTestActive = new CustomEvent( 'CorABTestActive' );
// window.dispatchEvent( abTestActive );

// one liner CorABTestActive
// window.dispatchEvent( new CustomEvent( 'CorABTestActive' ) );
